import { Type } from "@sinclair/typebox";
import { TypeBoxToType } from "@whatslly/types/TypeBoxToType";
import { DLPPolicy } from "./DLPPolicy";

export const DLPSettings = Type.Object({
  policies: Type.Array(DLPPolicy),
  allow_dlp_ai: Type.Boolean(),
  hasDlpDetector: Type.Boolean(),
  internalPhones: Type.Optional(Type.Array(Type.String())),
});
export type DLPSettings = TypeBoxToType<typeof DLPSettings>;
